import "amfe-flexible";
import Vue from "vue";
import App from "./App.vue";
import router from "./router"; // 路由
import store from "./store/index"; // vuex
import VueI18n from "vue-i18n";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/font/iconfont.css";
import { messages } from "@/assets/js/data"; // 语言包
import findKey from "lodash/findKey.js"; // 多语言相关组件
import { getOrigin } from "@/utils/getUserAgent"; // 全局注册组件
import Cookies from "js-cookie";

import {
  Toast,
  Dialog,
  Notify,
  PasswordInput,
  NumberKeyboard,
  DatetimePicker,
  Picker,
  ImagePreview,
  Uploader,
} from "vant";
import "vant/lib/index.css";
import "./tailwind.css";
console.log(8866555);
import { v3 } from "@/api"; // vuex
// Vue.use(Vant);
Vue.prototype.$Dialog = Dialog;
Vue.prototype.$Toast = Toast;
Vue.prototype.$Notify = Notify;
// import 'lib-flexible'

Vue.config.productionTip = false;
Vue.use(PasswordInput);
Vue.use(NumberKeyboard);
Vue.use(DatetimePicker);
Vue.use(Picker);
Vue.use(ImagePreview);
Vue.use(Uploader);
let lang = "zh-cn";
Vue.use(VueI18n);
Vue.prototype.$cookies = Cookies; // 设置cookie
Vue.prototype.$store = store; // vuex
Vue.prototype.$v3 = v3; // vuex

Vue.use(ElementUI);
const commit = Vue.prototype.$store;
// 处理域名
if (window.location.host.includes(".com")) {
  // 设置获取主域名
  const host = window.location.host.split(".").splice(1, 2);
  commit.commit("base/sethost", host.join("."));
}
let getdata = {};
const appagentparam = getOrigin(); // app进来的数据test
console.log(navigator, 88665111111, appagentparam);
if (appagentparam?.userId) {
  // 判断如果为app传入contentcookie则使用app数据
  Object.assign(getdata, appagentparam);
  const userInfo = {
    userId: getdata?.userId,
    // nick: getdata?.nick,
    avatar: getdata?.avatar,
  };
  commit.commit("base/setUser", userInfo);
  commit.commit("base/setbasedata", getdata?.BasicData); // 获取basedata
  const basetype = getdata?.BasicData?.split(",")?.[2];
  commit.commit("base/setbasetype", basetype);
  commit.commit("base/setisReister", getdata?.isReister); // 是否新注册
  const navHeight = parseFloat(getdata.navHeight).toFixed(2);

  commit.commit("base/getNavHeight", navHeight); // 设置为APP
  commit.commit("base/setuserCountInfo", {
    flag: getdata?.falg,
    code: getdata?.phonecode,
  }); // 设置
  commit.commit("base/setwikinum", getdata?.wikinum); // 设置天眼号

  if (getdata.enterpriseCode) {
    // 是否有code
    commit.commit("base/setEnterpriseCode", getdata.enterpriseCode); // 设置企业code
  } else {
    commit.commit("base/setEnterpriseCode", ""); // 设置企业code
  }

  commit.commit("base/setLangCode", getdata.language.toLowerCase()); // 存入当前语言
  commit.commit("base/setCountryCode", getdata.countrycode); // 存入当前国家
  lang = getdata.language.toLowerCase();

  commit.commit("base/setIsGlobal", getdata?.isGlobal); // 是否为国际版
}

if (getdata.userId) commit.commit("base/setUserid", getdata.userId); // 设置userid

// ...对数据进行存储

const i18n = new VueI18n({
  locale: lang,
  messages,
  silentTranslationWarn: true,
});
VueI18n.prototype.translation = function (value) {
  let en = require("@/assets/languages/TXT_zh-CN.json");
  let val = findKey(en, function (o) {
    return o === value;
  });
  if (!val) {
    return value + "(前端未翻译)";
  }
  return this.$t(val);
};
Vue.prototype.$v = i18n.translation; // i18n
Vue.prototype.$bus = new Vue(); //总线
document.querySelector("html").setAttribute("lang", lang);
i18n.location = lang;
if (['ar', 'ur'].includes(lang)) {
  document.querySelector("html").setAttribute("dir", "rtl");
} else {
  document.querySelector("html").setAttribute("dir", "ltr");
}
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
